import { render } from "./AppSidebar.vue?vue&type=template&id=1551fc7b"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/espenbirk/Sites/byttgass-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__